import { render, staticRenderFns } from "./GrFileChip.vue?vue&type=template&id=1485d8f7&scoped=true"
import script from "./GrFileChip.vue?vue&type=script&lang=js"
export * from "./GrFileChip.vue?vue&type=script&lang=js"
import style0 from "./GrFileChip.vue?vue&type=style&index=0&id=1485d8f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485d8f7",
  null
  
)

export default component.exports